import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DatePicker from 'antd/es/date-picker';
import { useState } from 'react';
import { useTranslations } from '../../features/providers/translations-provider';
import theme from '../../theme';
import Button from '../common/button';
import Div from '../common/div';
import Typography from '../common/typography';
const PauseJourneyModal = ({ notification, setPauseModal, handlePauseSubscription, }) => {
    const { t } = useTranslations();
    const [pausedUntil, setPausedUntil] = useState(null);
    const { grant_id, industry_id, tag_id, subject_title } = notification;
    return (_jsxs(Div, { flex: "column", align: "center", justify: "center", gap: 24, children: [_jsxs(Div, { flex: "column", align: "center", justify: "center", gap: 8, children: [_jsx(Typography, { elementTheme: "subtitle1", children: t('notification|changePauseTitle') }), _jsx(Typography, { elementTheme: "body1", children: subject_title })] }), _jsx(Div, { flex: "column", align: "center", justify: "center", gap: 8, children: _jsx(DatePicker, { onChange: (value) => setPausedUntil(value === null || value === void 0 ? void 0 : value.toDate()) }) }), _jsxs(Div, { flex: "row", gap: 8, justify: "center", children: [_jsx(Button, { onClick: () => setPauseModal(false), size: "small", style: {
                            backgroundColor: theme.colors.grey_4,
                            borderColor: theme.colors.grey_4,
                        }, children: t('button|cancel') }), _jsx(Button, { onClick: () => {
                            handlePauseSubscription(grant_id, industry_id, tag_id, undefined, pausedUntil);
                            setPauseModal(false);
                        }, size: "small", style: {
                            backgroundColor: theme.colors.purple_2,
                            borderColor: theme.colors.purple_2,
                        }, children: t('button|confirm') })] })] }));
};
export default PauseJourneyModal;
